import { render, staticRenderFns } from "./mentally.vue?vue&type=template&id=1dbbfda0&scoped=true"
import script from "./mentally.vue?vue&type=script&lang=js"
export * from "./mentally.vue?vue&type=script&lang=js"
import style0 from "./mentally.vue?vue&type=style&index=0&id=1dbbfda0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dbbfda0",
  null
  
)

export default component.exports